import { QuickTable, QuickTableFilterTabs } from "../../components";
import { paymentDisplayFormatter } from "./paymentDisplayFormatter";
import { IPaymentViewProps } from "./Payments";
import { PaymentDetailsModal } from "./PaymentDetailsModal";
import { Route, Routes } from "react-router-dom";

export const View = (props: IPaymentViewProps) => {
  return (
    <div className="payments-page">
      <QuickTable
        id={props.queryStringTableName}
        prefixFiltersWithId
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
            filterPrefix={props.queryStringTableName}
          />
        }
        displayFormatter={paymentDisplayFormatter}
        onExport={props.onExport}
        openDetailsModal={
          props.hideDetailsModal ? undefined : props.openDetailsModal
        }
        disableClickOnTargetClassNames={["copy-btn"]}
        disableClickOnColumns={["actions, more"]}
      />

      <Routes>
        <Route path=":id/details" element={<PaymentDetailsModal />} />
      </Routes>
    </div>
  );
};
